// extracted by mini-css-extract-plugin
export var container = "_sd-0";
export var table = "_sd-2";
export var tableWrapper = "_sd-1";